/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileDgn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zm-2.584 2.09c.225-.03.43-.055.584-.09l-.093.135-.069.1C18.334 6.9 16.221 9.943 17.491 12.6l.025.052c.15.291.313.581.475.864l-1.954 2.026-.882-3.206-.233.21c-.15.137-.3.277-.45.417-1.423 1.329-2.86 2.67-4.68 1.013l-.203-.184-.25.596-.144.342c-.477 1.143-.955 2.287-1.665 3.318-.69 1.001-1.671 1.153-2.775 1.324-.246.038-.499.077-.755.127.14-.186.098-.13.056-.076 1.892-2.498 3.282-5.304 4.422-8.224a167.75 167.75 0 0 0 1.36-3.667l.215-.596c.385-1.061 1.267-1.19 2.288-1.338.3-.044.614-.09.93-.16a4.376 4.376 0 0 1-.013.024c-.4.827-3.71 7.646-1.5 7.574 1.777-.057 3.6-3.626 4.732-5.844.29-.57.536-1.05.723-1.358l.366-.594c.274-.45 1.152-.563 1.837-.651z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileDgn as FillFileDgn };
